import { render, staticRenderFns } from "./ClientClassManager.vue?vue&type=template&id=8d38e75e&scoped=true"
import script from "./ClientClassManager.vue?vue&type=script&lang=js"
export * from "./ClientClassManager.vue?vue&type=script&lang=js"
import style0 from "./ClientClassManager.vue?vue&type=style&index=0&id=8d38e75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d38e75e",
  null
  
)

export default component.exports